import { jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
const FormGrid = React.forwardRef(function FormGrid2({ minColumnWidth, className, style, ...rest }, ref) {
  const gridStyle = minColumnWidth === void 0 ? style : {
    ...style,
    "--ev-form-grid-min": typeof minColumnWidth === "number" ? `${minColumnWidth}px` : minColumnWidth
  };
  return /* @__PURE__ */ jsx("div", { ref, className: cx("ev-form-grid", className), style: gridStyle, ...rest });
});
FormGrid.displayName = "FormGrid";
export {
  FormGrid
};
//# sourceMappingURL=FormGrid.js.map
